<template>
  <div class="home-page">
    <div class="hero-section">
      <picture class="banner-picture">
        <source media="(max-width: 768px)" srcset="@/assets/img/banner/home_m.jpg" />
        <img class="banner-bg" src="@/assets/img/banner/home.jpg" alt="" />
      </picture>
      <div class="banner-overlay"></div>
      <div class="container">
        <h1 class="hero-title">紫藤检测 · 守护质量安全</h1>
        <p class="hero-subtitle">专业第三方检测机构，CMA/CNAS双重认证<br>为您提供准确、公正、高效的检测服务</p>
        <div class="hero-actions">
          <router-link to="/services" class="cta-button primary">了解更多</router-link>
          <router-link to="/verification" class="cta-button outline">报告查询</router-link>
        </div>
      </div>
    </div>
    
    <!-- Services Section -->
    <div class="section services-section">
      <div class="container">
        <h2 class="section-title">核心服务领域</h2>
        <p class="section-subtitle">覆盖多领域的专业检测能力，满足您的多样化需求</p>
        
        <div class="services-grid">
          <div class="service-card">
            <div class="icon-wrapper">🌿</div>
            <h3>环境检测</h3>
            <p>水质、大气、土壤、噪声等全方位环境监测服务，助力生态文明建设。</p>
          </div>
          <div class="service-card">
            <div class="icon-wrapper">🍎</div>
            <h3>食品农产品</h3>
            <p>农残、兽残、重金属、微生物等指标检测，守护舌尖上的安全。</p>
          </div>
          <div class="service-card">
            <div class="icon-wrapper">🧴</div>
            <h3>日化用品</h3>
            <p>化妆品、洗护清洁等产品质量安全指标检测与合规评估。</p>
          </div>
          <div class="service-card">
            <div class="icon-wrapper">🏗️</div>
            <h3>建材与工程</h3>
            <p>建筑材料物理化学性能测试，室内环境污染检测。</p>
          </div>
          <div class="service-card">
            <div class="icon-wrapper">💧</div>
            <h3>公共卫生</h3>
            <p>公共场所卫生、饮用水卫生、消毒餐饮具检测。</p>
          </div>
          <div class="service-card">
            <div class="icon-wrapper">🔬</div>
            <h3>技术咨询</h3>
            <p>实验室建设咨询、质量体系认证咨询、标准制修订服务。</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Why Us Section -->
    <div class="section why-us-section">
      <div class="container">
        <h2 class="section-title">为什么选择紫藤检测</h2>
        <div class="features-grid">
          <div class="feature-item">
            <div class="feature-number">01</div>
            <h3>权威资质认证</h3>
            <p>具备CMA资质认定和CNAS实验室认可，报告具有法律效力，国际互认。</p>
          </div>
          <div class="feature-item">
            <div class="feature-number">02</div>
            <h3>先进仪器设备</h3>
            <p>配备国际一流的分析检测仪器，确保数据的准确性和可靠性。</p>
          </div>
          <div class="feature-item">
            <div class="feature-number">03</div>
            <h3>专业技术团队</h3>
            <p>硕博士领衔的技术团队，丰富的行业经验，解决复杂检测难题。</p>
          </div>
          <div class="feature-item">
            <div class="feature-number">04</div>
            <h3>高效服务响应</h3>
            <p>标准化的服务流程，快速出具报告，急客户之所急。</p>
          </div>
        </div>
      </div>
    </div>
    
    <!-- News Section -->
    <div class="section news-section">
      <div class="container">
        <div class="section-header">
          <h2 class="section-title">新闻资讯</h2>
          <router-link to="/news" class="view-more">查看更多 &rarr;</router-link>
        </div>
        
        <div class="news-list">
          <div class="news-item" v-for="n in homeNews" :key="n.slug">
            <router-link class="news-cover-link" :to="`/news/${n.slug}`">
              <img :src="n.cover" :alt="n.title" />
            </router-link>
            <div class="news-date">
              <span class="day">{{ n.day }}</span>
              <span class="month">{{ n.month }}</span>
            </div>
            <div class="news-content">
              <router-link class="news-title-link" :to="`/news/${n.slug}`">
                <h3 class="news-title">{{ n.title }}</h3>
              </router-link>
              <p class="news-excerpt">{{ n.excerpt }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    const { articles } = require('@/data/news.js')
    const format = (iso) => {
      const d = new Date(iso)
      const day = `${d.getDate()}`.padStart(2, '0')
      const month = `${d.getMonth() + 1}`.padStart(2, '0') + '月'
      return { day, month }
    }
    const homeNews = [...articles]
      .sort((a, b) => new Date(b.date) - new Date(a.date))
      .slice(0, 3)
      .map((a) => {
        const { day, month } = format(a.date)
        return { slug: a.slug, title: a.title, excerpt: a.excerpt, cover: a.cover, day, month }
      })
    return { homeNews }
  }
}
</script>

<style scoped>
.hero-section {
  color: #fff;
  text-align: center;
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 70px);
  display: flex;
  align-items: center;
}

.banner-picture {
  position: absolute;
  inset: 0;
  z-index: 0;
  display: block;
  overflow: hidden;
}

.banner-bg {
  position: absolute;
  inset: 0;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 50% 50%;
  transform-origin: center;
  transform: scale(1.04);
  animation: homeBannerZoom 18s ease-in-out infinite alternate;
}

.banner-overlay {
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background:
    radial-gradient(900px 480px at 15% 15%, rgba(255, 255, 255, 0.04) 0%, rgba(255, 255, 255, 0) 60%),
    radial-gradient(700px 420px at 85% 30%, rgba(255, 214, 102, 0.04) 0%, rgba(255, 214, 102, 0) 62%),
    radial-gradient(900px 520px at 60% 90%, rgba(146, 214, 255, 0.04) 0%, rgba(146, 214, 255, 0) 62%),
    linear-gradient(135deg, rgba(125, 74, 199, 0.44) 0%, rgba(74, 20, 140, 0.40) 100%);
  z-index: 1;
}

.banner-overlay::before {
  content: '';
  position: absolute;
  inset: -22%;
  background:
    radial-gradient(closest-side at 20% 25%, rgba(255, 255, 255, 0.16), rgba(255, 255, 255, 0)),
    radial-gradient(closest-side at 78% 28%, rgba(255, 189, 92, 0.18), rgba(255, 189, 92, 0)),
    radial-gradient(closest-side at 60% 86%, rgba(104, 210, 255, 0.18), rgba(104, 210, 255, 0)),
    radial-gradient(closest-side at 35% 78%, rgba(196, 148, 255, 0.18), rgba(196, 148, 255, 0));
  filter: blur(24px);
  opacity: 0.9;
  animation: homeBannerBlobs 16s ease-in-out infinite alternate;
}

.banner-overlay::after {
  content: '';
  position: absolute;
  inset: 0;
  background:
    radial-gradient(circle at 12px 12px, rgba(255, 255, 255, 0.16) 2px, rgba(255, 255, 255, 0) 3px),
    radial-gradient(circle at 42px 52px, rgba(255, 255, 255, 0.12) 1px, rgba(255, 255, 255, 0) 2px);
  background-size: 60px 60px, 120px 120px;
  opacity: 0.22;
  transform: translate3d(0, 0, 0);
  animation: homeBannerParticles 22s linear infinite;
  pointer-events: none;
}

.hero-section .container {
  z-index: 2;
  position: relative;
  padding: 120px 20px;
}

.hero-title {
  font-size: 3.5rem;
  margin-bottom: 20px;
  font-weight: 700;
  text-shadow: 0 2px 10px rgba(0,0,0,0.2);
  animation: homeFadeUp 800ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.hero-subtitle {
  font-size: 1.2rem;
  margin-bottom: 50px;
  opacity: 0.9;
  line-height: 1.6;
  max-width: 800px;
  margin-left: auto;
  margin-right: auto;
  animation: homeFadeUp 900ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.hero-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
  animation: homeFadeUp 900ms 220ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.cta-button {
  display: inline-block;
  padding: 14px 40px;
  border-radius: 30px;
  font-weight: bold;
  text-decoration: none;
  transition: all 0.3s;
  font-size: 16px;
  will-change: transform;
}

.cta-button.primary {
  background-color: #fff;
  color: #7D4AC7;
}

.cta-button.primary:hover {
  background-color: #f0f0f0;
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(0,0,0,0.2);
}

.cta-button.outline {
  background-color: transparent;
  border: 2px solid #fff;
  color: #fff;
}

.cta-button.outline:hover {
  background-color: rgba(255,255,255,0.1);
  transform: translateY(-2px);
}

@keyframes homeFadeUp {
  from {
    opacity: 0;
    transform: translate3d(0, 14px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

@keyframes homeBannerZoom {
  from { transform: scale(1.04); }
  to { transform: scale(1.10); }
}

@keyframes homeBannerBlobs {
  0% { transform: translate3d(-2%, -1%, 0) scale(1); }
  50% { transform: translate3d(2%, 2%, 0) scale(1.04); }
  100% { transform: translate3d(-1%, 3%, 0) scale(1.02); }
}

@keyframes homeBannerParticles {
  from { background-position: 0 0, 0 0; }
  to { background-position: 0 -360px, 0 -720px; }
}

@media (prefers-reduced-motion: reduce) {
  .banner-bg,
  .banner-overlay::before,
  .banner-overlay::after,
  .hero-title,
  .hero-subtitle,
  .hero-actions,
  .services-grid .service-card,
  .features-grid .feature-item,
  .news-list .news-item {
    animation: none !important;
  }
}

/* Sections General */
.section {
  padding: 80px 0;
}

.section-title {
  text-align: center;
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 15px;
  font-weight: 600;
}

.section-subtitle {
  text-align: center;
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  position: relative;
  z-index: 1;
}

/* Services Section */
.services-section {
  background-color: #fff;
}

.services-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 30px;
}

.service-card {
  padding: 40px 30px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.05);
  transition: all 0.3s;
  border: 1px solid #f0f0f0;
  text-align: center;
  will-change: transform;
}

.services-grid .service-card {
  opacity: 0;
  animation: homeFadeUp 700ms 120ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.services-grid .service-card:nth-child(2) { animation-delay: 180ms; }
.services-grid .service-card:nth-child(3) { animation-delay: 240ms; }
.services-grid .service-card:nth-child(4) { animation-delay: 300ms; }

.service-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 30px rgba(125, 74, 199, 0.1);
  border-color: #e0d4f5;
}

.icon-wrapper {
  font-size: 48px;
  margin-bottom: 20px;
  height: 80px;
  width: 80px;
  line-height: 80px;
  border-radius: 50%;
  background-color: #f8f4fc;
  margin-left: auto;
  margin-right: auto;
  transition: all 0.3s;
}

.service-card:hover .icon-wrapper {
  background-color: #7D4AC7;
  color: #fff;
}

.service-card h3 {
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 15px;
}

.service-card p {
  color: #666;
  line-height: 1.6;
}

/* Why Us Section */
.why-us-section {
  background-color: #f8f4fc; /* Light purple tint */
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 40px;
  margin-top: 50px;
}

.feature-item {
  position: relative;
  padding: 20px;
  border-radius: 14px;
  transition: transform 0.3s, background-color 0.3s;
  will-change: transform;
}

.features-grid .feature-item {
  opacity: 0;
  animation: homeFadeUp 700ms 160ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.features-grid .feature-item:nth-child(2) { animation-delay: 220ms; }
.features-grid .feature-item:nth-child(3) { animation-delay: 280ms; }
.features-grid .feature-item:nth-child(4) { animation-delay: 340ms; }

.feature-item:hover {
  transform: translateY(-6px);
  background-color: rgba(255, 255, 255, 0.7);
}

.feature-number {
  font-size: 4rem;
  font-weight: 800;
  color: rgba(125, 74, 199, 0.1);
  position: absolute;
  top: -20px;
  left: 0;
  z-index: 0;
  transition: color 0.3s, transform 0.3s;
}

.feature-item:hover .feature-number {
  color: rgba(125, 74, 199, 0.18);
  transform: translate3d(0, -2px, 0);
}

.feature-item h3 {
  position: relative;
  z-index: 1;
  font-size: 1.4rem;
  color: #333;
  margin-bottom: 15px;
}

.feature-item p {
  position: relative;
  z-index: 1;
  color: #666;
  line-height: 1.6;
}

/* News Section */
.news-section {
  background-color: #fff;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 50px;
}

.section-header .section-title {
  margin-bottom: 0;
  text-align: left;
}

.view-more {
  color: #7D4AC7;
  text-decoration: none;
  font-weight: 600;
  transition: all 0.3s;
}

.view-more:hover {
  color: #4A148C;
  transform: translateX(5px);
}

.news-list {
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.news-list .news-item {
  opacity: 0;
  animation: homeFadeUp 700ms 180ms cubic-bezier(0.2, 0.8, 0.2, 1) both;
}

.news-list .news-item:nth-child(2) { animation-delay: 240ms; }
.news-list .news-item:nth-child(3) { animation-delay: 300ms; }

.news-item {
  display: flex;
  align-items: flex-start;
  padding: 20px;
  border-radius: 8px;
  transition: background-color 0.3s;
}

.news-cover-link {
  width: 170px;
  height: 110px;
  border-radius: 12px;
  overflow: hidden;
  flex-shrink: 0;
  margin-right: 18px;
  display: block;
}

.news-cover-link img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transform: scale(1.02);
  transition: transform 0.35s;
}

.news-item:hover .news-cover-link img {
  transform: scale(1.08);
}

.news-title-link {
  text-decoration: none;
  display: inline-block;
}

.news-item:hover {
  background-color: #f9f9f9;
}

.news-date {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #7D4AC7;
  color: #fff;
  width: 70px;
  height: 70px;
  border-radius: 8px;
  margin-right: 25px;
  flex-shrink: 0;
}

.news-date .day {
  font-size: 24px;
  font-weight: bold;
  line-height: 1;
  margin-bottom: 4px;
}

.news-date .month {
  font-size: 12px;
}

.news-content h3 {
  font-size: 1.2rem;
  color: #333;
  margin-bottom: 10px;
  transition: color 0.3s;
}

.news-item:hover .news-content h3 {
  color: #7D4AC7;
}

.news-excerpt {
  color: #666;
  margin: 0;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .hero-section .container {
    padding: 90px 14px;
  }

  .hero-title {
    font-size: 2.2rem;
  }
  
  .hero-subtitle {
    font-size: 1rem;
  }
  
  .hero-actions {
    flex-direction: column;
    align-items: center;
  }
  
  .cta-button {
    width: 100%;
    max-width: 280px;
    text-align: center;
  }
  
  .section-header {
    flex-direction: row;
    align-items: center;
  }
  
  .news-item {
    flex-direction: column;
  }

  .news-cover-link {
    width: 100%;
    height: 190px;
    margin-right: 0;
    margin-bottom: 12px;
  }
  
  .news-date {
    margin-bottom: 15px;
  }
}
</style>
